const DOCUMENT_FILE_TYPE = {
    DOCUMENT: 'DOCUMENT',
    REPORT: 'REPORT',
    AUTHORIZATION: 'AUTHORIZATION'
};

const DOCUMENT_FILE_ENTITY_TYPE = {
    EMPLOYEE: 'EMPLOYEE',
    CLIENT: 'CLIENT',
    AUTHORIZATION: 'AUTHORIZATION'
}

const DOCUMENT_FILE_STATUS = {
    PENDING_APPROVAL: {
        status:'PENDING_APPROVAL',
        text: 'Pending approval',
        color:'orange'
    },
    EXPIRED: {
        status: 'EXPIRED',
        text: 'Expired',
        color:'red'
    },
    UP_TO_DATE: {
        status: 'UP_TO_DATE',
        text: 'Ready',
        color:'green'
    },
    INACTIVE: {
        status: 'INACTIVE',
        text: 'Inactive',
        color:'violet'
    },
    DELETED: {
        status: 'DELETED',
        text: 'Deleted',
        color:'red'
    },
};

export {
    DOCUMENT_FILE_TYPE,
    DOCUMENT_FILE_STATUS,
    DOCUMENT_FILE_ENTITY_TYPE
}